<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div class="my-cars-view">
      <div class="header-wrapper cars-header">
        <dashboard-header text="Samochody" />
        <p>
          Lista Twoich dodanych samochodów
        </p>
      </div>
      <div class="my-cars-container">
        <template v-for="(car, index) in cars">
          <car-block
            :key="index"
            :car="car"
          />
        </template>
        <add-car v-if="!loading" />
      </div>
      <div class="header-wrapper partner-header">
        <dashboard-header text="Partner Serwisowy" />
        <p>
          Twój wybrany Partner Serwisowy
        </p>
      </div>
      <div class="my-partner-container">
        <add-partner v-if="!userPartner" />
        <service-station-block
          class="card-block standard-view"
          v-else
          :with-slot="true"
          :show-details="true"
          :set-favourite="true"
          :show-image="true"
          :service-station="userPartner"
        >
          <standard-button
            class="fluid change-partner-button"
            @buttonClick="changePartnerModal()"
            text="Zmień Partnera Serwisowego"
          />
        </service-station-block>
      </div>
    </div>
  </transition>
</template>

<script>
import DashboardHeader from '~/DashboardHeader';
import ServiceStationBlock from '~/ServiceStationBlock';
import StandardButton from '~/StandardButton';
import AddPartner from '~/AddPartner';
import AddCar from '~/AddCar';
import CarBlock from '~/CarBlock';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    loading: {
      default: true,
      type: Boolean,
    },
  },
  components: {
    DashboardHeader,
    ServiceStationBlock,
    StandardButton,
    AddCar,
    AddPartner,
    CarBlock,
  },
  computed: {
    ...mapGetters({
      cars: 'myCars/getMyCars',
      userPartner: 'user/getFavouritePartner',
    }),
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      setModalStep: 'modal/setModalStep',
      setModalMode: 'modal/setModalMode',
      resetCarSpecs: 'car/resetCarSpecs',
    }),
    changePartnerModal() {
      this.setModalContent({
        changeFavourite: true,
      });
      this.setModalStep('change_partner');
      this.toggleModal();
    },
  },
};
</script>
